class FAQ {
    constructor() {
        this.setFAQ();
    }

    setFAQ() {
        const questionElements = document.querySelectorAll('.faq .question-container');
        questionElements.forEach((questionElement) => {
            const question = questionElement.querySelector('.question');
            question.addEventListener('click', () => this.toggleQuestion(questionElement));
        });
    }

    toggleQuestion(questionElement) {
        questionElement.classList.toggle('open');

        // Allow time for the FAQ animation to complete before refreshing ScrollTrigger
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 700);

        // Extra timeout to ensure scroll trigger refreshes after any potential animation has completed
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 2000);
    }
}
new FAQ();
